class AuraOverlay {

  constructor(element) {

    this.element = element;
    this.panel = element.querySelector('.aura-overlay__panel');

    this.activeTrigger = null;

    this.focusableSelectors = [
      'a[href]',
      'button:not([disabled])',
      'textarea:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(',');

    this.bindEvents();

  }

  bindEvents() {

    this.element
      .querySelectorAll('[data-overlay-close]')
      .forEach(button => {

        button.addEventListener('click', () => {

          this.close();

        });

      });

    document.addEventListener('keydown', event => {

      if (!this.element.classList.contains('is-open')) return;

      if (event.key === 'Escape') {

        this.close();

      }

      if (event.key === 'Tab') {

        this.trapFocus(event);

      }

    });

  }

  open(trigger = null) {

    this.activeTrigger = trigger;

    this.element.classList.add('is-open');

    this.element.setAttribute(
      'aria-hidden',
      'false'
    );

    document.body.style.overflow = 'hidden';

    requestAnimationFrame(() => {

      this.panel.focus();

    });

  }

  close() {

    this.element.classList.remove('is-open');

    this.element.setAttribute(
      'aria-hidden',
      'true'
    );

    document.body.style.overflow = '';

    if (this.activeTrigger) {

      this.activeTrigger.focus();

    }

  }

  toggle(trigger = null) {

    if (this.element.classList.contains('is-open')) {

      this.close();

      return;

    }

    this.open(trigger);

  }

  trapFocus(event) {

    const focusable = this.panel.querySelectorAll(
      this.focusableSelectors
    );

    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey) {

      if (document.activeElement === first) {

        event.preventDefault();

        last.focus();

      }

      return;

    }

    if (document.activeElement === last) {

      event.preventDefault();

      first.focus();

    }

  }

}

document.addEventListener('DOMContentLoaded', () => {

  document
    .querySelectorAll('.aura-overlay')
    .forEach(element => {

      const overlay = new AuraOverlay(element);

      document
        .querySelectorAll(
          `[data-overlay-open="${element.id}"]`
        )
        .forEach(button => {

          button.addEventListener('click', () => {

            overlay.open(button);

          });

        });

    });

});